/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningCircleIcon20Light = forwardRef('WarningCircleIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.25 12.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" }),
        React.createElement("path", { d: "M10 6a.5.5 0 0 0-1 0v3.9a.5.5 0 0 0 1 0V6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 9.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0ZM9.5 3a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Z" })));
});
